import React from 'react';
import { Section } from '../../Section';
import { SectionTitle } from '../../Typography';
import { TimelineItem } from './index';
import { Timeline } from './elements';
import { mediaQueries } from '../../../style/breakpoints';
import { HandShake, MouseClick, Form, Phone, Desktop } from 'src/components/Icons/AdmissionProcess';

const AdmissionProcess = React.memo(({ id, fromFormationsPage }) => {
  return (
    <Section theme="dark" id={id}>
      <SectionTitle
        isCenter
        css={{
          [mediaQueries.phoneOnly]: {
            paddingBottom: 55,
          },
          [mediaQueries.tabletPortraitUp]: {
            paddingBottom: 100,
          },
          [mediaQueries.tabletLandscapeUp]: {
            paddingBottom: 120,
          },
        }}
      >
        Processus d'admission
      </SectionTitle>
      <Timeline>
        <TimelineItem
          title="Assistez à une"
          CTAScroll="réunion d’information"
          icon={<HandShake />}
        />
        <TimelineItem
          right
          title="Cliquez sur le bouton"
          CTAForm="Postuler"
          fromFormationsPage={fromFormationsPage}
          icon={<MouseClick />}
        />
        <TimelineItem
          title="Remplissez le"
          CTAForm="formulaire en ligne"
          fromFormationsPage={fromFormationsPage}
          icon={<Form />}
        />

        {fromFormationsPage.certification === 'RNCP6' && (
          <TimelineItem right title="Vous passez le test de logique" icon={<Desktop />} />
        )}
        <TimelineItem
          right={fromFormationsPage.certification === 'RNCP6' ? false : true}
          title="Sandrine vous rappelle rapidement"
          icon={<Phone />}
        />
      </Timeline>
    </Section>
  );
});

export default AdmissionProcess;
